import { createUniqueId } from "./unique-id.js";
export const createCommandRequestId = () => createUniqueId("req");
